import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
import store from '../store'
import Cookies from 'js-cookie'
import { Loading } from 'element-ui'
import { TokenKey, removeToken, getToken } from '@/utils/auth'
import Util from '@/assets/js/util.js'
import Logan from 'logan-web';
import JSONbig from 'json-bigint'

baseURL = process.env.API_ROOT;
ossUrl = location.protocol + process.env.OSS_URL;
baseURL = baseURL + `${Cookies.get('upgraded') == '0' ? '' : '/v2'}`;
Vue.prototype.$Util = Util
Vue.prototype.$baseUrl = baseURL
Vue.prototype.$ossUrl = ossUrl;
Vue.prototype.$ossDownLoad = location.protocol + process.env.OSS_DOWNLOAD;
Vue.prototype.$baseImgUrl = baseURL + '/img/'
Vue.prototype.$baseImgUrlNo = baseURL + '/img'
Vue.prototype.$Cookies = Cookies
Vue.prototype.$ajaxExport = function (url, params, cb) {
  let get_url = Util.getUrlPara(url, params, this)
  let xhr = new XMLHttpRequest()
  xhr.open('GET', get_url, true)
  xhr.setRequestHeader('Authorization', Cookies.get('token'))
  xhr.responseType = 'blob'
  xhr.onload = function () {
    if (this.status === 200) {
      var blob = this.response
      var reader = new FileReader()
      reader.readAsDataURL(blob)
      reader.onload = function (e) {
        if (cb) {
          cb(e)
        }
      }
    }
  }
  xhr.send()
}
Vue.prototype.$ajaxPost = function (url, data, config = { isString: true }, isMask) {
  if (data instanceof FormData) {
    return service.post(url, data, config)
  }
  return service.post(url, config.isString? qs.stringify(data): data, config)
  // if (config === 'upload') {
  //   return service.post(url, data, {type: 'upload'})
  // }
  // if (config == true || arguments[3] == true) {
  //   return service.post(url, qs.stringify(data), true)
  // } else {
  //   return service.post(url, qs.stringify(data), config)
  // }
}
Vue.prototype.$ajaxDelete = function (url, data, config, isMask) {
  return service.delete(url, {params: data})
}
Vue.prototype.$ajaxPut = function (url, data, config, isMask) {
  return service.put(url, data, true)
}
Vue.prototype.$ajaxGet = function (url, data, config, isMask) {
  let get_url = Util.getUrlPara(url, data, this)
  if (config == true || arguments[2] == true) {
    return service.get(get_url, true)
  } else {
    return service.get(get_url, config)
  }
}
/*创建axios实例*/
const service = axios.create({
  baseURL: baseURL,
  timeout: 100000,
  showMask:false,
  transformResponse: [function (data) {
    // 对 data 进行任意转换处理 必须是JSON字符串的时候才处理
    return Util.isJSON(data) ? JSONbig({"storeAsString": true, "useNativeBigInt": true}).parse(data) : data;
  }],
});
let mask = {}; //遮罩对象

let pending = {};  //声明一个对象来存储每次请求的唯一标识和取消函数
let CancelToken = axios.CancelToken; //axios的CancelToken
const removePending = (key) => {
  if (pending[key]) { //如果是重复请求，执行cancelToken
    pending[key]('取消重复')
  }
  delete pending[key] //删除标识
};
const getSign = (config = {}) => { //请求的唯一标识：接口+请求参数
  return config.url + '?' + config.data
};
/*请求拦截器*/
service.interceptors.request.use(function (config) {
  // 阿里云上传鉴权接口
  if (config.url.search('/image-upload/aliyun/oss/policy') > -1) {
    config.baseURL = process.env.NODE_ENV !== 'production' ? `${location.protocol}//homo.jc-test.cn/` : `${location.protocol}//homo.jc-saas.com/`;
    config.headers.apikey = process.env.NODE_ENV !== 'production' ? 'Cxl2LjfM7se0efZ6AUlny0AeX5uI5W3ReK46' : '82b3nohbVk5NLcGKUnWcRGMleCAGMvDsF37N';
  }
  // 阿里云上传接口
  const ossList = ['jxc-oss.jc-test.cn', 'jxc-oss.niimbot.com'];
  if (ossList.some(val => config.url.search(val) > -1)) {
    config.baseURL = ossUrl;
  }
  const dataArr = config.url.split('?');
  const content = `${config.method}请求接口${config.url}，请求参数${config.data ? config.data : dataArr.length && dataArr[1]}`;
  Logan.logWithEncryption(content, 1);
  let sign = getSign(config)
  removePending(sign)
  config.cancelToken = new CancelToken((c) => { //创建cancel token
    pending[sign] = c
  });

  //发送请求之前
  if (config[0] == true) {
    mask = Loading.service({fullscreen: true, text: '拼命加载中....'})
  }
  //让每个请求携带Authorization
  if (config.type === 'upload') {
    config.headers['Content-Type'] = 'multipart/form-data;'
  }
  if (store.getters.token) {
    config.headers['Authorization'] = getToken()
    config.headers['deviceCode'] = window.navigator.appVersion;
  }
  return config
}, function (error) {
  mask.close();
  //请求出错
  return Promise.reject(error)
});

/*响应拦截器*/
service.interceptors.response.use(function (res) {
  let sign = getSign(res.config);
  removePending(sign); //移除已完成的请求
  /*数据响应*/
  if (res.status === 200) {
    if (res.data.status == '999') {
      removeToken();
      Cookies.set('status', 999);
      location.reload();
    } else if (res.data.status == '403') {
      removeToken();
      Cookies.set('status', 403);
      location.reload();
    } else {
      Cookies.remove('status');
    }
    if (typeof mask.close == 'function') {
      mask.close();
    }
  }

  // 判断一下响应中是否有 token，如果有就直接使用此token替换掉本地的token
  var token = res.headers.authorization;
  if (token) {
    // 如果 header 中存在 token，那么触发 refreshToken 方法，替换本地的 token
    this.$store.dispatch('RefreshToken', token)
  }
  return res
}, function (error) {
  // switch (error.response.status) {
  //   //403触发logout方法,清除本地的数据并将用户重定向至登录页面
  //   case 403:
  //     return this.$store.dispatch('LogOut').then(() => {
  //       Message.error('登录失效，请重新登录！')
  //       // location.reload();
  //     })
  //     break
  //   //400弹出一条错误提示给用户
  //   case 400:
  //     return this.$Message.error(error.response.data.error)
  //     break
  // }
  //响应出错
  mask.close()

  return Promise.reject(error)
})

Vue.prototype.$ajax = service
export { baseURL }
export default service



// WEBPACK FOOTER //
// ./src/utils/request.js